// eslint-disable-next-line import/no-webpack-loader-syntax
import zindex from 'sass-extract-loader?{"plugins": ["sass-extract-js"]}!../../assets/stylesheets/app/base/_zindex.scss';

export default zindex;
